/**
 * Thermal observation overlay — reuses the exact scene-rendering pipeline
 * (fetchImageFromServer → getCollectionImage → displayFootprintImageNew).
 * Only the payload's `action` differs from a normal scene fetch.
 */
export function formatObservationTooltipTime(value: any): string {
  if (!value) {
    return 'N/A';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return String(value);
  }

  return date.toISOString().replace('T', ' ').replace('Z', ' UTC');
}

export function formatObservationTooltipCoords(value: any): string {
  const raw = String(value ?? '').trim();
  if (!raw) {
    return 'N/A';
  }

  const cleaned = raw.replace(/;/g, '').trim();
  return cleaned || 'N/A';
}

export function formatObservationTooltipTemperature(value: any): string {
  const temperature = value ?? value?.temperature ?? value?.temparature;
  return temperature ? String(temperature).trim() : 'N/A';
}

export function buildObservationTooltipContent(
  info: any,
  datePipe?: {
    transform: (value: any, pattern: string, timezone?: string) => string | null;
  }
): string {
  const coords = formatObservationTooltipCoords(info?.observationValue);

  const captureDate = info?.capture_date || info?.captureDate;

  const observationTime = datePipe ? datePipe.transform(new Date(captureDate), 'dd/MM/yyyy HH:mm:ss', 'UTC') ?? 'N/A' : formatObservationTooltipTime(captureDate);

  const temperature = formatObservationTooltipTemperature(
    info?.temperature ?? info?.temparature
  );

  return `
    <div style="line-height:1.6;">
      <div><strong>Observation Time:</strong> ${observationTime}</div>
      <div><strong>Temperature:</strong> ${temperature}K</div>
      <div><strong>Lng:</strong> ${coords.split(',')[0] ?? 'N/A'}</div>
      <div><strong>Lat:</strong> ${coords.split(',')[1] ?? 'N/A'}</div>
    </div>
  `;
}

export function renderThermalObservation(
  host: {
    collection: any;
    fetchImageFromServer: (
      collection: any,
      sensorObj: any,
      scene: any,
      isVdapChange?: boolean,
      info?: any
    ) => void;
  },
  sensor: any,
  scene: any,
  info: any,
  imageType: any,
): boolean {
  const isThermalAreaObservation =
    info?.thermal_observation === true && String(info?.data_type ?? '').trim().toLowerCase() === 'area' && imageType === 'png';

  if (!isThermalAreaObservation || !sensor || !scene?.id) {
    return false;
  }

  const sensorObj = {
    sensorId: sensor.id,
    sceneId: scene.id,
    action: 'observation',
    fileType: scene.imageType,
  };

  host.fetchImageFromServer(host.collection, sensorObj, scene, false, info);
  return true;
}
